module.exports = __webpack_public_path__ + "img/apple-icon-114x114.2a967560.png";